import PropTypes from 'prop-types'
import { Flex, Box, Text } from '@chakra-ui/react'
import { NormalButton, PrimaryButton } from '@!/components/Button'
import { WarningIcon } from '@!/components/Icon'

const BUTTON_WIDTH = { base: '142px', md: '168px' }
const TEXT_WIDTH = '327px'
const CONTENT_WIDTH = { base: TEXT_WIDTH, md: '348px' }
const HORIZONTAL_PADDING = '24px'
// デザイン上のヘッダー直下の余白
const CONTENT_TOP_PADDING = { base: '32px', md: '56px' }
// デザイン上のフッター（パンくず）までの余白
const CONTENT_BOTTOM_PADDING = { base: '156px', md: '368px' }

// 「はい」「いいえ」を選ぶまで作品の内容を見せないため、ページのコンテンツとして表示する
export const AgeVerification = ({ onAgree, onDisagree }) => (
  <Box bg="bg.primary" px={HORIZONTAL_PADDING} pt={CONTENT_TOP_PADDING} pb={CONTENT_BOTTOM_PADDING}>
    <Flex direction="column" alignItems="center" mx="auto" w="100%" maxW={CONTENT_WIDTH}>
      <WarningIcon boxSize="33px" color="label.primary" />
      <Text as="h1" mt="16px" fontSize="md" fontWeight="semibold" lineHeight="22px" color="label.primary">
        年齢確認
      </Text>
      <Text mt="24px" w="100%" maxW={TEXT_WIDTH} fontSize="xs" fontWeight="300" lineHeight="18px" color="label.primary" textAlign="center">
        ここから先は、18歳以上の方を対象としたコンテンツ（センシティブな表現を含む作品）が含まれています。
      </Text>
      <Text mt="32px" w="100%" maxW={TEXT_WIDTH} fontSize="xs" fontWeight="semibold" lineHeight="20px" color="label.primary" textAlign="center">
        あなたは18歳以上ですか？
      </Text>
      <Flex mt="16px" gap="12px" alignItems="flex-start">
        <Box w={BUTTON_WIDTH}>
          <PrimaryButton variant="outline" height="37px" fontSize="sm" onClick={onAgree}>
            はい
          </PrimaryButton>
        </Box>
        <Box w={BUTTON_WIDTH}>
          <NormalButton height="37px" fontSize="sm" onClick={onDisagree}>
            いいえ
          </NormalButton>
          <Text mt="4px" fontSize="3xs" fontWeight="300" lineHeight="normal" color="label.primary">
            （マンガBANGブックスTOPへ）
          </Text>
        </Box>
      </Flex>
    </Flex>
  </Box>
)

AgeVerification.propTypes = {
  onAgree: PropTypes.func.isRequired,
  onDisagree: PropTypes.func.isRequired,
}
